

const timePickerStyle = theme => ({
  timePicker: {
    marginTop: '32px',
    marginLeft: '18px',
  },
});

export default timePickerStyle;